import PixelHero from './PixelHero'

export default PixelHero
